export default "__VITE_ASSET__7d588728__"